@if (dataLoaded) {
  <div class="flex justify-center">
    <div class="inline-block shadow-2xl rounded-lg overflow-hidden">
      <p-table
        [value]="playerList"
        [paginator]="false"
        [responsiveLayout]="'scroll'"
        [size]="'small'"
        >
        <ng-template pTemplate="header">
          <tr>
            <th colspan="6" class="table-header" style="text-align: center;">
              TOP 10 - {{ seasonName || 'Season ' + season_id }}
            </th>
          </tr>
          <tr>
            <th style="text-align: center;">#</th>
            <th>Fahrer</th>
            <th style="text-align: center;">Punkte</th>
            <th style="text-align: center;">Rennen</th>
            <th style="text-align: center;">Siege</th>
            <th style="text-align: center;">Top 5</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-player let-rowIndex="rowIndex">
          <tr [routerLink]="['/playerDetails', player.player_id]" style="cursor: pointer;">
            <td style="text-align: center; background-color: red; color: white;">{{ rowIndex + 1 }}</td>
            <td>
              <b>{{ player.name_gt7 }}</b><br /><span style="font-size: 0.6rem;">{{ player.car_name }}</span>
            </td>
            <td style="text-align: center;">{{ player.total_points_v3 }}</td>
            <td style="text-align: center;">{{ player.race_count }}</td>
            <td style="text-align: center;">{{ player.wins ?? 0 }}</td>
            <td style="text-align: center;">{{ player.top5 ?? 0 }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" style="text-align: center;">Keine Daten vorhanden</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
@if (!dataLoaded) {
  <p>Lade Daten ...</p>
}
